(function ($) {
  Drupal.behaviors.beWhoYouAreHeaderV1 = {
    attach: function (context) {
      var self = this;

      $(document).on('bwyaHeader::loadedYoutubeIframeAPI', function (e) {
        self.vidSetup(e);
      });
      // CX-4265 add class to the empty title name field, to perform css fucntionality
      $(".bwya__tile--cta-container .bwya__img-tile--cta-three-wrapper[data-bwyatitle=' ']", context).addClass('bwya-titleempty');
    },
    createVideoPlayerDiv: function ($elem, i) {
      var id = $elem.attr('class') + '-' + i;

      $elem
        .append('<div />')
        .children('div')
        .attr('id', id);

      return id;
    },

    addVideo: function (ytId, iframeId) {
      var player = new YT.Player(iframeId, {
        height: '100%',
        width: '100%',
        videoId: ytId,
        playerVars: {
          // controls: 0
        },
        events: {
          onReady: function (event) {
            // Don't autoplay on mobile
            if (!Modernizr.touch) {
              event.target.playVideo();
            }
          },
          onStateChange: function (event) {
            // stuff
          },
          onApiChange: function (event) {
          }
        }
      });
    },
    vidSetup: function (event) {
      // Padding under header copy
      var paddingBelowCopy = $('.bwya__header--text').data('padding');

      if (paddingBelowCopy != null) {
        var padding = paddingBelowCopy.toString();

        padding = padding.replace(/[^0-9]/g, '');
        $('.bwya__header--text', context).css('padding-bottom', padding + 'px');
      }
      // Video Setup.
      var self = this;

      $('.bwya__header').each(function (i) {
        var $me = $(this),
          $content = $('.bwya__header--video', $me),
          $vids = $content.filter(function (i) {
            return ($(this).data('video-provider') == 'youtube' && $(this).data('youtube-id').length > 0) || ($(this).data('video-provider') == 'youku' && $(this).data('youku-id').length > 0);
          }),
          $player = $('.bwya__header--video-player', $content);

        $vids.each(function () {
          var $wrap = $(this),
            videoType = $wrap.data('video-provider'),
            ytId = $wrap.data('youtube-id');

          $wrap.click(function (e) {
            // Do something useless
            e.preventDefault();

            // Reset the current player wrapper
            $player.removeClass('active').empty();

            // Create a new div for the player to take over
            var iframeId = self.createVideoPlayerDiv($player, Math.floor(+new Date() / 1000));

            // Add the 'active' class to the player for spacing
            $player.addClass('active');

            // Instantiate the video
            if (videoType === 'youtube') {
              self.addVideo(ytId, iframeId);
            } else if (videoType === 'youku') {
              var youkuVideoIframe = youkuVideoEmbed.addYoukuVideo($wrap.data('youku-id'), iframeId);

              $wrap.find('.bwya__header--video-player').append(youkuVideoIframe);
            }

            // Do something else that's useless
            return false;
          });
        });
      });
      // Video Image
      $('.bwya__header__image').once().click(function (e) {
        $('.bwya__header__image').hide();
      });
    }
  };
  $(document).bind('youtubeIframeAPI.loaded', function (e) {
    // Trigger at end of stack.
    $(document).ready(function () {
      $(document).trigger('bwyaHeader::loadedYoutubeIframeAPI', e);
    });
  });
}

)(jQuery);
